import msg, {get_msg_txt} from "../../../../consts/msg";

function getYesNoLabel({lang, value}){
    return value===true ? get_msg_txt(lang, msg.yes) : get_msg_txt(lang, msg.no);
}

export default getYesNoLabel;